// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"caaf65ba","453":"60f9ae76","455":"986d3674","977":"94aed993"}[chunkId] + ".chunk.js";
};